import axios from "axios";
import { importPublicKey, wrapAesKey } from "./licenseImageCrypto";

const authHeader = () => ({ accessToken: localStorage.getItem("accessToken") });

/**
 * Users that encrypted license data is shared with: admins + members of a
 * permission group with license access. Each entry: { id, username, fullName, publicKey }.
 * publicKey may be null for users that have not created a key pair yet.
 */
export async function fetchLicenseRecipients(apiUrl) {
  const { data } = await axios.get(`${apiUrl}/licenses/recipients`, { headers: authHeader() });
  return data;
}

/**
 * Wrap an (extractable) AES-GCM key for every authorized recipient that has a
 * public key. Returns [{ userId, envelope }] ready to send to an upload/share
 * endpoint. Throws if the current user is not among the wrappable recipients
 * (they would not be able to decrypt their own upload).
 */
export async function wrapKeyForAllRecipients(aesKey, apiUrl, currentUserId) {
  const recipients = await fetchLicenseRecipients(apiUrl);
  const keys = [];
  for (const r of recipients) {
    if (!r.publicKey) continue;
    const pub = await importPublicKey(r.publicKey);
    keys.push({ userId: r.id, envelope: await wrapAesKey(aesKey, pub) });
  }
  if (currentUserId != null && !keys.some((k) => k.userId === currentUserId)) {
    throw new Error(
      "Kein Verschlüsselungsschlüssel im Profil hinterlegt – bitte zuerst im Profil erstellen."
    );
  }
  return keys;
}
